import axios from 'axios';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSnackbar } from '../../components/utils/snackbarProvider/SnackbarContextProvider';
import { TENANT_URL } from '../../config';

const FoodItemContext = createContext(null);

export function useFoodItems() {
  return useContext(FoodItemContext);
}

export const FoodItemsProvider = ({ children }) => {
  const [plansList, setPlansList] = useState([]);
  const [foodCategories, setCategories] = useState([]);
  const [allCategories, setAll] = useState(0);
  const [activeCategories, setActive] = useState(0);
  const [inActiveCategories, setInactive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagedList, setPagedList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [links, setLinks] = useState(null);
  const [meta, setMeta] = useState([]);
  const { show } = useSnackbar();
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    if (currentPage !== 0) getPlansList(currentPage);
  }, [currentPage]);
  useEffect(() => {
    if (keyword.length > 1) getPlansList(1);
    else if (keyword.length === 0) getPlansList(1);
  }, [keyword]);
  useEffect(() => {
    getPlansList(1);
    getCategories();
    getCardData();
  }, []);

  const getCardData = async () => {
    const token = JSON.parse(localStorage.getItem('tenantdata')).token;
    const getConfig = {
      method: 'get',
      url: `${TENANT_URL}/card/food/item`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    setLoading(true);
    try {
      const response = await axios(getConfig);
      setAll(response.data.total_count);
      setActive(response.data.active);
      setInactive(response.data.inactive_count);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getPlansList = async (pageNumber) => {
    const token = JSON.parse(localStorage.getItem('tenantdata')).token;
    const getConfig = {
      method: 'get',
      url: `${TENANT_URL}/food/item`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      params: {
        page: pageNumber,
        ...(keyword.length > 1 && { name: keyword }),
      },
    };
    try {
      const response = await axios(getConfig);
      setPlansList(response.data.data);
      setPagedList(response.data.data);
      setLinks(response.data.links);
      setMeta(response.data.meta);
      setCurrentPage(response.data.meta.current_page);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const deletePlan = async (id) => {
    const token = JSON.parse(localStorage.getItem('tenantdata')).token;
    var deleteConfig = {
      method: 'delete',
      url: `${TENANT_URL}/food/item/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios(deleteConfig);
      await getPlansList();
      await getCardData();
      show(response.data?.message);
    } catch (error) {
      console.error(error);
      show(error?.response?.data?.error || error?.message, 'error');
      setLoading(false);
    }
  };

  const createPlan = async (
    name,
    description,
    is_active,
    is_global,
    price,
    food_category_id,
    food_item_image,
    handleClose
  ) => {
    const formData = new FormData();
    if (!is_global) {
      formData.append('name', name);
      formData.append('description', description);
      formData.append('is_active', is_active ? 1 : 0);
      formData.append('is_global', 0);
      formData.append('price', price);
      formData.append('food_category_id', food_category_id);
      formData.append('food_item_image', food_item_image);
    } else {
      formData.append('name', name);
      formData.append('description', description);
      formData.append('is_active', is_active ? 1 : 0);
      formData.append('is_global', 1);
      formData.append('price', price);
      formData.append('food_item_image', food_item_image);
    }
    try {
      const token = JSON.parse(localStorage.getItem('tenantdata')).token;
      const addConfig = {
        method: 'post',
        url: `${TENANT_URL}/food/item`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const addResponse = await axios({ ...addConfig, data: formData });
      show('Item added Successfully');
      await getPlansList();
      await getCardData();
      handleClose();
    } catch (error) {
      console.log(error);
      show(Object.values(error.response.data.message), 'error');
      setLoading(false);
    }
  };

  const getPlanById = async (id) => {
    const token = JSON.parse(localStorage.getItem('tenantdata')).token;
    var config = {
      method: 'get',
      url: `${TENANT_URL}/food/item/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  const getCategories = async () => {
    const token = JSON.parse(localStorage.getItem('tenantdata')).token;
    var config = {
      method: 'get',
      url: `${TENANT_URL}/active/food/category`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const response = await axios(config);
      setCategories(response.data.data);
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  const updatePlan = async (
    id,
    name,
    description,
    price,
    food_category_id,
    is_active,
    is_global,
    food_item_image,
    handleClose
  ) => {
    const formData = new FormData();
    if (!is_global) {
      // data = JSON.stringify({
      //   name,
      //   food_category_id, // Include food_category_id when is_global is false
      //   description,
      //   is_active,
      //   is_global: false,
      //   price,
      //   // Explicitly set to false
      // });
      formData.append('name', name);
      formData.append('description', description);
      formData.append('is_active', is_active ? 1 : 0);
      formData.append('is_global', 0);
      formData.append('price', price);
      formData.append('food_category_id', food_category_id);
      formData.append('food_item_image', food_item_image);
    } else {
      formData.append('name', name);
      formData.append('description', description);
      formData.append('is_active', is_active ? 1 : 0);
      formData.append('is_global', 1);
      formData.append('price', price);
      formData.append('food_item_image', food_item_image);
      // formData.append('food_category_id', null);
      //   food_category_id: null,
      // data = JSON.stringify({
      //   name,
      //   food_category_id: null,
      //   description,
      //   is_active,
      //   is_global: true,
      //   price,
      // });
    }

    try {
      const token = JSON.parse(localStorage.getItem('tenantdata')).token;
      var config = {
        method: 'POST',
        url: `${TENANT_URL}/food/item/${id}?_method=PUT`,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      };
      const updateResponse = await axios(config);
      await getPlansList();
      await getCardData();
      show('Item updated successfully');
      handleClose();
    } catch (error) {
      show(Object.values(error.response.data.message)[0], 'error');
      setLoading(false);
    }
  };

  const values = {
    plansList,
    loading,
    deletePlan,
    createPlan,
    pagedList,
    currentPage,
    setCurrentPage,
    getPlanById,
    updatePlan,
    foodCategories,
    allCategories,
    activeCategories,
    inActiveCategories,
    links,
    meta,
    keyword,
    setKeyword,
  };

  return (
    <FoodItemContext.Provider value={values}>
      {children}
    </FoodItemContext.Provider>
  );
};
